import {
  UPDATE_INPUT,
  UPDATE_RECEIPT_ID,
  UPDATE_ADD_INPUT,
  UPDATE_ADD_CONF,
  RESET_ADD_CONF,
  CHANGE_MODIFY_MODE,
  CHANGE_VALID,
  REGISTER,
  ADD_REGISTER,
} from './actions';

const AppReducer = (state, action) => {
  switch(action.type){
    case UPDATE_INPUT: { 
      const { updInput } = action;
      const { workCategory, workCategorySub, workCategoryOtherDetail, workDetailText, employmentPlacementDispatching, companyNameText, dept, chargePersonNameText, tel, email, address, ekiCd, ekiName, clickID, mediaID } = updInput;
      return { ...state, workCategory, workCategorySub, workCategoryOtherDetail, workDetailText, employmentPlacementDispatching, companyNameText, dept, chargePersonNameText, tel, email, address, ekiCd, ekiName, clickID, mediaID };
    }
    case UPDATE_ADD_INPUT: {
      const { updAddInput } = action;
      const {
        workInfoContent,
        skillLevel,
        hourSalaryMin,
        hourSalaryMax,
        suggestHourSalary,
        skillLevelExcel,
        skillLevelPowerpoint,
        bgdOfRecruitment,
        workEnvi,
        workStyle,
        overTime,
        startTime,
        endTime,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workInfoContentCmnt,
        skillOtherCmnt,
        bgdOfRecruitmentCmnt,
        workStyleCmnt,
        startTimeCmnt,
        endTimeCmnt,
        workPeriodCmnt,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        timeSavingAva,
        useCar,
        smokeEnvi,
        welfare,
      } = updAddInput;
      return { ...state,
        workInfoContent,
        skillLevel,
        hourSalaryMin,
        hourSalaryMax,
        suggestHourSalary,
        skillLevelExcel,
        skillLevelPowerpoint,
        bgdOfRecruitment,
        workEnvi,
        workStyle,
        overTime,
        startTime,
        endTime,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workInfoContentCmnt,
        skillOtherCmnt,
        bgdOfRecruitmentCmnt,
        workStyleCmnt,
        startTimeCmnt,
        endTimeCmnt,
        workPeriodCmnt,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        timeSavingAva,
        useCar,
        smokeEnvi,
        welfare,
      };
    }
    case UPDATE_ADD_CONF: {
      const { updAddConf } = action;
      const { 
        desiredStartDateKubun,
        desiredStartDate,
        hourSalaryMin,
        hourSalaryMax,
        timeSavingAva,
        overtimeHoursMin,
        overtimeHoursMax,
        strWorkInfo,
        skillLevelExcel,
        skillLevelPowerpoint,
        strWorkEnvi,
        strOtherSkill,
        strWorkPeriod,
        strDayOfTheWeek,
        strWorkTime,
        workStyle,
        overTime,
        workPeriod,
        bgdOfRecruitment,
        otherComment,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        useCar,
        smokeEnvi,
        welfare,
      } = updAddConf;
      return { ...state,
        desiredStartDateKubun,
        desiredStartDate,
        hourSalaryMin,
        hourSalaryMax,
        timeSavingAva,
        overtimeHoursMin,
        overtimeHoursMax,
        strWorkInfo,
        skillLevelExcel,
        skillLevelPowerpoint,
        strWorkEnvi,
        strOtherSkill,
        strWorkPeriod,
        strDayOfTheWeek,
        strWorkTime,
        workStyle,
        overTime,
        workPeriod,
        bgdOfRecruitment,
        otherComment,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        useCar,
        smokeEnvi,
        welfare,
      };
    }
    case RESET_ADD_CONF: {
      return { ...state,
        desiredStartDateKubun: '',
        desiredStartDate: '',
        hourSalaryMin: '',
        hourSalaryMax: '',
        timeSavingAva: '',
        overtimeHoursMin: '',
        overtimeHoursMax: '',
        workInfo: [],
        workInfoContent: [],
        strWorkInfo: '',
        skillLevel: '01',
        suggestHourSalary: '',
        skillLevelExcel: '',
        skillLevelPowerpoint: '',
        workEnvi: [],
        strWorkEnvi: '',
        strOtherSkill:'',
        strWorkPeriod:'',
        strDayOfTheWeek:'',
        strWorkTime:'',
        workStyle: '',
        overTime: '',
        startTime: '',
        endTime: '',
        workPeriod: '',
        bgdOfRecruitment: '',
        otherComment:'',
        checkPointUseCar: '',
        checkPointHolidayWork: '',
        checkPointRemoteWork: '',
        checkPointRemoteWorkCount: '',
        checkPointWelfare: [],
        checkPointSmokeEnvi: '',
        remoteWork: '',
        remoteWorkCount: '',
        holidayWork: '',
        useCar: '',
        smokeEnvi: '',
        welfare: [],
        workInfoContentCmnt: '',
        skillOtherCmnt: '',
        bgdOfRecruitmentCmnt: '',
        workStyleCmnt: '',
        startTimeCmnt: '',
        endTimeCmnt: '',
        workPeriodCmnt: '',
      };
    }
    case UPDATE_RECEIPT_ID: {
      const { updReceiptID } = action;
      const { receiptID } = updReceiptID;
      return { ...state, receiptID };
    }
    case CHANGE_MODIFY_MODE: {
      const { isModify } = action;
      return { ...state, isModify };
    }
    case CHANGE_VALID: {
      const { path, valid } = action;
      const { validMap } = state;
      return { ...state, validMap: { ...validMap, [path]: valid } };
    }
    case REGISTER: {
      return { ...state, isRegistered: true };
    }
    case ADD_REGISTER: {
      return { ...state, isAddRegistered: true };
    }
    default: {
      return state;
    }
  }
};

export default AppReducer;
